export default __webpack_public_path__ + "static/logo-cantodaterra-e0e86021c273b9b4c56483637dd17175.svg";